<template>
  <div class="bg-white rounded-lg p-5">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'VCard',
  };

</script>
